/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `None` - NONE
 * * `TotalCount` - TOTAL_COUNT
 * * `IncompleteCount` - INCOMPLETE_COUNT
 * * `CompletedPercent` - COMPLETED_PERCENT
 * * `TotalCountPoints` - TOTAL_COUNT_POINTS
 * * `IncompleteCountPoints` - INCOMPLETE_COUNT_POINTS
 * * `CompletedPercentPoints` - COMPLETED_PERCENT_POINTS
 */
export enum SummaryStatisticKind {
  NONE = 'None',
  TOTAL_COUNT = 'TotalCount',
  INCOMPLETE_COUNT = 'IncompleteCount',
  COMPLETED_PERCENT = 'CompletedPercent',
  TOTAL_COUNT_POINTS = 'TotalCountPoints',
  INCOMPLETE_COUNT_POINTS = 'IncompleteCountPoints',
  COMPLETED_PERCENT_POINTS = 'CompletedPercentPoints',
}
